import React, { useEffect, useState } from 'react';
import './CatalogPage.css';

/* Ícones SVG dos grupos */
function IconLayers() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </svg>
  );
}
function IconMap() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
      <line x1="8" y1="2" x2="8" y2="18" />
      <line x1="16" y1="6" x2="16" y2="22" />
    </svg>
  );
}
function IconDatabase() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    </svg>
  );
}
function IconInfo() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  );
}

const GROUP_ICONS = [IconLayers, IconMap, IconDatabase, IconInfo, IconLayers, IconMap, IconDatabase, IconInfo];
const GROUP_COLORS = ['#2799C5', '#27ae60', '#c8960a', '#c0392b', '#7f5af0', '#2799C5', '#27ae60', '#c8960a'];

function GroupCard({ group, index, onNavigate }) {
  const Icon = GROUP_ICONS[index % GROUP_ICONS.length];
  const color = GROUP_COLORS[index % GROUP_COLORS.length];
  const totalLayers = group.categories?.reduce((acc, cat) => acc + (cat.layers?.length || 0), 0) || 0;

  return (
    <article
      className="cat-card"
      style={{ '--card-color': color }}
    >
      <div className="cat-card__icon" aria-hidden="true">
        <Icon />
      </div>
      <h3 className="cat-card__title">{group.name}</h3>
      {group.description && (
        <p className="cat-card__desc">{group.description}</p>
      )}
      <div className="cat-card__meta">
        <span className="cat-card__badge">
          {group.categories?.length || 0} categorias
        </span>
        <span className="cat-card__badge">
          {totalLayers} camadas
        </span>
      </div>

      {group.categories && group.categories.length > 0 && (
        <ul className="cat-card__cats" aria-label="Categorias">
          {group.categories.slice(0, 4).map((cat) => (
            <li key={cat.id} className="cat-card__cat-item">
              <span className="cat-card__cat-dot" aria-hidden="true" />
              {cat.name}
            </li>
          ))}
          {group.categories.length > 4 && (
            <li className="cat-card__cat-item cat-card__cat-more">
              + {group.categories.length - 4} mais...
            </li>
          )}
        </ul>
      )}

      <button
        className="cat-card__cta"
        onClick={() => onNavigate('home')}
        aria-label={`Ver camadas de ${group.name} no mapa`}
      >
        Ver no Mapa →
      </button>
    </article>
  );
}

export default function CatalogPage({ onNavigate }) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/catalog')
      .then(r => {
        if (!r.ok) throw new Error('Erro ao carregar catálogo');
        return r.json();
      })
      .then(data => {
        setGroups(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <main className="cat-page">
      <div className="cat-container">

        <header className="cat-page-header">
          <button
            className="cat-back-btn"
            onClick={() => onNavigate('home')}
            aria-label="Voltar ao mapa principal"
          >
            ← Voltar ao Mapa
          </button>
          <div className="cat-header-text">
            <h1 className="cat-page-title">Catálogo de Dados</h1>
            <p className="cat-page-sub">
              Explore os conjuntos de dados geoespaciais disponíveis no Painel InfoVivo.
              Todos os dados são referentes ao Plano Municipal de Saneamento Básico (PMSB).
            </p>
          </div>
        </header>

        {loading && (
          <div className="cat-loading" role="status" aria-live="polite">
            <div className="cat-spinner" aria-hidden="true" />
            <span>Carregando catálogo...</span>
          </div>
        )}

        {error && (
          <div className="cat-error" role="alert">
            <IconInfo />
            <p>{error}</p>
            <button className="cat-retry-btn" onClick={() => window.location.reload()}>
              Tentar novamente
            </button>
          </div>
        )}

        {!loading && !error && groups.length === 0 && (
          <div className="cat-empty">
            <IconDatabase />
            <h2>Nenhum dado disponível no momento</h2>
            <p>O catálogo será preenchido conforme os dados do PMSB forem publicados.</p>
          </div>
        )}

        {!loading && !error && groups.length > 0 && (
          <>
            <p className="cat-summary" aria-live="polite">
              {groups.length} grupo{groups.length !== 1 ? 's' : ''} de dados disponíveis
            </p>
            <div className="cat-grid">
              {groups.map((group, i) => (
                <GroupCard
                  key={group.id}
                  group={group}
                  index={i}
                  onNavigate={onNavigate}
                />
              ))}
            </div>
          </>
        )}

        <section className="cat-info-section" aria-labelledby="cat-info-title">
          <h2 id="cat-info-title" className="cat-info-title">Sobre os Dados</h2>
          <div className="cat-info-grid">
            <div className="cat-info-card">
              <span className="cat-info-icon" aria-hidden="true">🌐</span>
              <h3>Fonte</h3>
              <p>Dados produzidos no âmbito do PMSB, integrados via GeoServer com camadas WMS/WFS.</p>
            </div>
            <div className="cat-info-card">
              <span className="cat-info-icon" aria-hidden="true">📅</span>
              <h3>Atualização</h3>
              <p>Os dados são atualizados conforme os horizontes de planejamento do PMSB (2024–2046).</p>
            </div>
            <div className="cat-info-card">
              <span className="cat-info-icon" aria-hidden="true">🔒</span>
              <h3>Acesso</h3>
              <p>Dados públicos disponíveis para todos. Camadas restritas exigem login com perfil adequado.</p>
            </div>
          </div>
        </section>

      </div>
    </main>
  );
}
